function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//import md5 from "md5"
import api from "@/api";
import { getQrcodeLoginParam } from "@/api/login";
import { mapActions } from "vuex";
import { timeFix } from "@/utils/util";
import Vue from "vue";
import { ACCESS_TOKEN, ENCRYPTED_STRING } from "@/store/mutation-types";
import { putAction, postAction, getAction } from "@/api/manage";
import { encryption, getEncryptedString } from "@/utils/encryption/aesEncrypt";
import store from "@/store/";
import { USER_INFO } from "@/store/mutation-types";
export default {
  name: "LoginAggr",
  components: {},
  data: function data() {
    return {
      customActiveKey: "tab1",
      loginBtn: false,
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      encryptedString: {
        key: "",
        iv: ""
      },
      state: {
        time: 60,
        smsSendBtn: false
      },
      validatorRules: {
        username: {
          rules: [{
            required: true,
            message: "请输入姓名!"
          }, {
            validator: this.handleUsernameOrEmail
          }]
        },
        password: {
          rules: [{
            required: true,
            message: "请输入身份证号!",
            validator: "click"
          }]
        },
        mobile: {
          rules: [{
            validator: this.validateMobile
          }]
        },
        captcha: {
          rule: [{
            required: true,
            message: "请输入验证码!"
          }]
        },
        inputCode: {
          rules: [{
            required: true,
            message: "请输入验证码!"
          }]
        }
      },
      verifiedCode: "",
      inputCodeContent: "",
      inputCodeNull: true,
      currentUsername: "",
      currdatetime: "",
      randCodeImage: "",
      requestCodeSuccess: false
    };
  },
  created: function created() {
    //this.initQrcode();
    this.currdatetime = new Date().getTime();
    this.getRouterData();
    this.handleChangeCheckCode();
  },
  methods: _objectSpread(_objectSpread({}, mapActions(["Login", "Logout", "PhoneLogin", "AggregateLogin"])), {}, {
    handleUsernameOrEmail: function handleUsernameOrEmail(rule, value, callback) {
      var regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
      if (regex.test(value)) {
        this.loginType = 0;
      } else {
        this.loginType = 1;
      }
      callback();
    },
    handleTabClick: function handleTabClick(key) {
      this.customActiveKey = key;
    },
    handleSubmit: function handleSubmit() {
      var _this = this;
      var that = this;
      var loginParams = {};
      that.loginBtn = true;
      // 使用账户密码登录
      if (that.customActiveKey === "tab1") {
        that.form.validateFields(["username", "password", "inputCode", "rememberMe"], {
          force: true
        }, function (err, values) {
          if (!err) {
            loginParams.username = values.username;
            loginParams.password = values.password;
            loginParams.remember_me = values.rememberMe;
            loginParams.captcha = that.inputCodeContent;
            loginParams.checkKey = that.currdatetime;
            console.log("登录参数", loginParams);
            that.AggregateLogin(loginParams).then(function (res) {
              _this.loginSuccess(res);
            }).catch(function (err) {
              that.requestFailed(err);
            });
          } else {
            that.loginBtn = false;
          }
        });
      }
    },
    getCaptcha: function getCaptcha(e) {
      var _this2 = this;
      e.preventDefault();
      var that = this;
      this.form.validateFields(["mobile"], {
        force: true
      }, function (err, values) {
        if (!values.mobile) {
          that.cmsFailed("请输入手机号");
        } else if (!err) {
          _this2.state.smsSendBtn = true;
          var interval = window.setInterval(function () {
            if (that.state.time-- <= 0) {
              that.state.time = 60;
              that.state.smsSendBtn = false;
              window.clearInterval(interval);
            }
          }, 1000);
          var hide = _this2.$message.loading("验证码发送中..", 0);
          var smsParams = {};
          smsParams.mobile = values.mobile;
          smsParams.smsmode = "0";
          postAction("/sys/sms", smsParams).then(function (res) {
            if (!res.success) {
              setTimeout(hide, 0);
              _this2.cmsFailed(res.message);
            }
            console.log(res);
            setTimeout(hide, 500);
          }).catch(function (err) {
            setTimeout(hide, 1);
            clearInterval(interval);
            that.state.time = 60;
            that.state.smsSendBtn = false;
            _this2.requestFailed(err);
          });
        }
      });
    },
    handleChangeCheckCode: function handleChangeCheckCode() {
      var _this3 = this;
      this.currdatetime = new Date().getTime();
      getAction("/sys/randomImage/number/".concat(this.currdatetime)).then(function (res) {
        if (res.success) {
          _this3.randCodeImage = res.result;
          _this3.requestCodeSuccess = true;
        } else {
          _this3.$message.error(res.message);
          _this3.requestCodeSuccess = false;
        }
      }).catch(function () {
        _this3.requestCodeSuccess = false;
      });
    },
    loginSuccess: function loginSuccess(res) {
      this.$emit('success');
      //如果在登录页
      if (this.$route.name == 'login') {
        if (this.$route.query.backUrl) {
          this.$router.push(this.$route.query.backUrl);
        } else {
          this.$router.push("/");
        }
      } else {
        window.location.reload();
      }
    },
    cmsFailed: function cmsFailed(err) {
      this.$notification["error"]({
        message: "登录失败",
        description: err,
        duration: 4
      });
    },
    requestFailed: function requestFailed(err) {
      this.$notification["error"]({
        message: "登录失败",
        description: ((err.response || {}).data || {}).message || err.message || "请求出现错误，请稍后再试",
        duration: 4
      });
      this.loginBtn = false;
    },
    validateMobile: function validateMobile(rule, value, callback) {
      if (!value || new RegExp(/^1[3456789]\d{9}$/).test(value)) {
        callback();
      } else {
        callback("您的手机号码格式不正确!");
      }
    },
    validateInputCode: function validateInputCode(rule, value, callback) {
      if (!value || this.verifiedCode == this.inputCodeContent) {
        callback();
      } else {
        callback("您输入的验证码不正确!");
      }
    },
    generateCode: function generateCode(value) {
      this.verifiedCode = value.toLowerCase();
    },
    inputCodeChange: function inputCodeChange(e) {
      this.inputCodeContent = e.target.value;
    },
    getRouterData: function getRouterData() {
      var _this4 = this;
      this.$nextTick(function () {
        if (_this4.$route.params.username) {
          _this4.form.setFieldsValue({
            username: _this4.$route.params.username
          });
        }
      });
    },
    //获取密码加密规则
    getEncrypte: function getEncrypte() {
      var _this5 = this;
      var encryptedString = Vue.ls.get(ENCRYPTED_STRING);
      if (encryptedString == null) {
        getEncryptedString().then(function (data) {
          _this5.encryptedString = data;
        });
      } else {
        this.encryptedString = encryptedString;
      }
    },
    initQrcode: function initQrcode() {
      getQrcodeLoginParam(window.location.pathname).then(function (res) {
        if (res.success) {
          var qrcodeParam = res.result;
          var s = document.createElement("script");
          s.type = "text/javascript";
          s.src = "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
          var wxElement = document.body.appendChild(s);
          wxElement.onload = function () {
            new window.WxLogin({
              id: "qrcode",
              appid: qrcodeParam.appId,
              scope: "snsapi_login",
              redirect_uri: qrcodeParam.redirectUrl,
              state: qrcodeParam.state,
              style: "black",
              href: "data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30uaW5mbywudGl0bGUsLnN0YXR1c19pY29uIHtkaXNwbGF5OiBub25lO30uaW1wb3dlckJveCAuc3RhdHVzIHt0ZXh0LWFsaWduOiBjZW50ZXI7fQ=="
            });
          };
        }
      });
    }
  })
};